import React from 'react';
import { useIntl } from 'react-intl';

import { CheckMarkSvg, MaestroCardSvg, MasterCardSvg, VisaCardSvg, AmexCardSvg } from '@assets';

import { FormSection } from '../form-section';
import { PaymentPlanCards } from '../payment-plan-cards';
import type { PaymentPlanOption } from '../../types';

import formStyles from '../../styles.module.scss';

interface PaymentMethodIntroSectionProps {
  onPlanChange: (plan: PaymentPlanOption) => void;
}

export function PaymentMethodIntroSection({
  onPlanChange,
}: PaymentMethodIntroSectionProps): React.ReactElement {
  const intl = useIntl();

  return (
    <FormSection title={intl.formatMessage({ id: 'certificates.payment.methodTitle' })}>
      <div className={formStyles.paymentMethodList}>
        <div className={formStyles.paymentMethodItem}>
          <CheckMarkSvg />
          <span>{intl.formatMessage({ id: 'certificates.payment.secureTransmission' })}</span>
        </div>
        <div className={formStyles.paymentMethodItem}>
          <CheckMarkSvg />
          <span>{intl.formatMessage({ id: 'certificates.payment.protectPersonalInfo' })}</span>
        </div>
      </div>
      <div className={formStyles.cards}>
        <MaestroCardSvg />
        <MasterCardSvg />
        <VisaCardSvg />
        <AmexCardSvg />
      </div>
      <PaymentPlanCards onPlanChange={onPlanChange} />
    </FormSection>
  );
}
